import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { DataService } from '../../services/data.service';
import { MaterialModule } from '../../material/material.module';
import { WorkTaskFormComponent } from "../work-task-form/work-task-form.component";
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-work-task-list',
  standalone: true,
  imports: [MaterialModule, WorkTaskFormComponent],
  templateUrl: './work-task-list.component.html',
  styleUrl: './work-task-list.component.scss'
})
export class WorkTaskListComponent implements OnInit {

  userDisplayName: string = '';
  userData:any;
  workTaskTemplates: any[] = [];
  selectedTask: any = null;
  currentTaskId: string | null = null;
  filteredTemplates: any[] = [];
  templateGroups: any[] = [];
  searchTerm: string = '';
  disableSearch: boolean = false;
  groupIds: any;

  constructor(
    public authService: AuthService,
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService
  ) {}


  ngOnInit(): void {

    // Subscribe to the authenticated user
    this.authService.user$.subscribe((user) => {
      if (user) {

        this.userDisplayName = user.displayName || '';
        const savedContext = this.dataService.getLocalContextId();
        this.dataService.getContextIdOfUser(user.uid);
        this.dataService.getGroupIdsOfUser(user.uid, savedContext).subscribe((groupIds) => {
          this.groupIds = groupIds;
        });

      } else {
        this.userDisplayName = '';
      }
    });

    // Get the current route task ID
    this.route.paramMap.subscribe((params) => {
      this.currentTaskId = params.get('id'); // Extract the task ID from the route
    });
    // Check for locally saved context ID
    const savedContext = this.dataService.getLocalContextId();
    if (savedContext) {
      //console.log('Using saved Context ID:', savedContext);
      this.fetchWorkTaskTemplates(savedContext); // Fetch templates for the saved context ID
      
      this.fetchGroups(savedContext);
    } else {
        this.dataService.contextIdChange$.subscribe((contextId) => {
          if (contextId) {
            //console.log('Context ID resolved:', contextId);
            this.fetchWorkTaskTemplates(contextId); 
            this.dataService.saveContextId(contextId);
          } else {
            this.notificationService.showError('Fehler: Kein Konto verfügbar.');
            console.warn('No context ID available for user');
          }
        });
        //console.log('No saved Context ID found, subscribing to user and context changes.');
    }
  }

  getTaskById(taskId: any): any {
    return this.workTaskTemplates.find((task) => task.id === taskId);
  }

  // TODO: REFACTOR
  groupBy(array: any[], id: string): any[] {
    return array.reduce((result: any[], currentItem: any) => {
      const groupId = currentItem[id] || '__no_key';
      const existingGroup = result.find(group => group.id === groupId);

      if (existingGroup) {
        existingGroup.templates.push(currentItem);
      } else {
        result.push({ id: groupId, templates: [currentItem] });
      }

      return result.sort((a, b) => (a.id === '__no_key' ? 1 : 0) - (b.id === '__no_key' ? 1 : 0));
    }, []);
  }

  getGroupName(groupId: string): string {
    const group = this.templateGroups.find((group) => group.id === groupId);
    return group ? group.title : '';
  }

  fetchGroups(contextId: string): void {
    this.dataService.getGroupData(contextId).subscribe(
      (groupNames) => {
        this.templateGroups = groupNames ? Object.entries(groupNames).map(([id, title]) => ({ id, title })) : [];
      },
      (error) => {
        console.error('Error fetching group names:', error);
      }
    );
  }

  // Fetch and auto-select
  fetchWorkTaskTemplates(contextId: string): void {
    this.dataService.getWorkTaskTemplateData(contextId).subscribe(
      (templates) => {

        templates.sort((a, b) => {
          if (a.sortIndex !== undefined && b.sortIndex !== undefined) {
            return (a.sortIndex ?? 1000) - (b.sortIndex ?? 1000);
          } else {
            const dateA = a.timeStamp ? a.timeStamp.toDate().getTime() : 0; // Default to 0 if undefined
            const dateB = b.timeStamp ? b.timeStamp.toDate().getTime() : 0; // Default to 0 if undefined
            return dateB - dateA; // Sort descending
          }
        });

        this.workTaskTemplates = templates;
        this.filteredTemplates = templates; // Initialize filtered list with all templates


        // if groupIds are existing, show only those with same id or without id
        //console.log(this.groupIds);
        if (this.groupIds && this.groupIds.length > 0) {
          this.filteredTemplates = this.workTaskTemplates.filter((template) => {
            return !template.usergroupIds || this.groupIds.some((groupId: string) => template.usergroupIds?.includes(groupId));
          });
        }
        else {
          // if there are no groupIDs, dont show templates with groupIDs
          this.filteredTemplates = this.workTaskTemplates.filter((template) => {
            return !template.userGroupIds;
          });
        
        }

        /* // if groupIds are existing, show only those
        //console.log(this.groupIds);
        if (this.groupIds && this.groupIds.length > 0) {
          this.filteredTemplates = this.workTaskTemplates.filter((template) => this.groupIds.some((groupId: string) => template.usergroupIds?.includes(groupId)));
          //console.log(this.filteredTemplates)
        } */

        // Auto-select the task and disable search if only one exists
        if (templates.length === 1 || templates.length === 0) {
          this.disableSearch = true;
          this.onSelectTask(templates[0]);
        }

        // Auto-select if the task ID is provided in the route
        if (this.currentTaskId) {
          const selectedTask = this.getTaskById(this.currentTaskId);
          if (selectedTask) {
            this.onSelectTask(selectedTask);
          }
        }

      },
      (error) => {
        console.error('Error fetching work task templates:', error);
        this.notificationService.showError('Fehler: Vorlagen konnten nicht geladen werden.');
      }
    );
  }

  onSelectTask(task: any): void {
    this.dataService.selectTask(task); // Notify DataService about the selected task
    this.router.navigate(['/tasks', task.id]); // Navigate to the task form with the task ID
  }

  isTaskActive(taskId: string): boolean {
    return this.currentTaskId === taskId; // Compare the route task ID with the task ID
  }

  filterTemplates(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredTemplates = this.workTaskTemplates.filter(
      (template) => template.title?.toLowerCase().includes(term)
    );
  }
}
